"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupPointCards = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactCoolInview = require("react-cool-inview");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _PickupPointCard = require("../PickupPointCard");
var _PickupPointCardsSkeleton = require("../PickupPointCardsSkeleton");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const PickupPointCards = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    loadMore,
    selectedPickupPointId,
    loadedPickupPoints,
    loading,
    pickupPoints,
    totalRecords
  } = (0, _contexts.usePickupPoints)();
  const onEnter = (0, _react.useCallback)(({
    unobserve
  }) => {
    loadMore();
    unobserve();
  }, [loadMore]);
  const {
    observe
  } = (0, _reactCoolInview.useInView)({
    rootMargin: '100px',
    onEnter
  });
  const rootRef = (0, _react.useRef)(null);
  // Scrolls to the selected pickup point when selectedPickupPointId changes
  (0, _react.useEffect)(() => {
    if (selectedPickupPointId != null) {
      (0, _utils.scrollToSelectedPickupPoint)({
        rootRef,
        selectedPickupPointId
      });
    }
  }, [selectedPickupPointId]);
  if (!loading && loadedPickupPoints === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Alert, {
        severity: "warning",
        children: translations.noPickupPointsFound
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    ref: rootRef,
    "data-testid": getTestId(_models.TestId.PickupPointCards),
    children: [pickupPoints.map((pickupPoint, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCard.PickupPointCard, {
      pickupPoint: pickupPoint,
      rootRef: index === pickupPoints.length - 1 && index !== totalRecords - 1 ? observe : undefined
    }, pickupPoint.deliveryChannelId)), loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCardsSkeleton.PickupPointCardsSkeleton, {}) : null]
  });
};
exports.PickupPointCards = PickupPointCards;